<template>
  <div id="detail" :class="['w3-modal', 'detail-wrapper', currentDetailContentId]" @click="clickDetailAndClose">
    <div class="w3-modal-content">
      <div class="w3-container w3-row detail-area">
        <div id="container_menu_detail" class="w3-col">
          <div v-if="menu" class="detail-menu-container">
            <div v-for="item in menu" :key="item.id" :class="item.id">
              <detail-flap v-tooltip.right="{content: item.name, delay: { show: 400, hide: 100 }, container: '#container_menu_detail .' + item.id}"
                :name="item.id"
                :id="id"
                :detailDefinitionChanged="detailDefinitionChanged"
                :visualDefinition="visualDefinition"
                @continueWithoutSaving="continueWithoutSaving"
                @continueSaving="continueSaving"
                @flapClicked="flapClicked"
              />
            </div>
          </div>
        </div>
        <div id="container_detail" :class="['w3-rest', {noButtons : visualDefinition.definition && visualDefinition.definition.hideButtons}]">
          <div id="container_inner_detail">
            <span class="w3-display-topright close_detail">
              <i v-if="!closing" class="sherpa-icon icon-cerrar" @click="closeDetail()"></i>
            </span>

            <div class="detail" v-show="!loadingDetail">
              <div origin-left="true" transition-duration="false" item-selector=".item">
                <transition name="fade" mode="out-in">
                  <router-view v-if="currentDetailContent && currentDetailContent.requestDefinition"
                    class="detail-view"
                    :saveDefinition="saveDefinition"
                    :saveDefinitionTo="saveDefinitionTo"
                    @formDataActionCalled="formDataActionCalled"
                    @refreshDefinition="definitionChanged"
                    @validatingFormError="validatingFormError"
                    @definitionLoaded="detailLoaded"
                  />
                  <router-view v-else-if="currentDetailContent && currentDetailContent.requestSearcher"
                    class="detail-view"
                    :searcher="currentDetailContent.requestSearcher"
                    :contentId="currentDetailContent.id"
                    @searcherLoaded="detailLoaded"
                  />
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as controlPanelTypes from '@/store/actions/controlPanel'
import * as appTypes from '@/store/actions/app'
import DetailFlap from '@/components/content/detail/flap'
import menu from '@/utils/menu'
import transport from 'vue-definition-utils/src/utils/transport'
import Visual from 'vue-definition-utils/src/utils/visual'

export default {
  name: 'detail',
  props: [
    'menu',
    'detailId',
    'definition',
    'object'
  ],
  components: {
    DetailFlap
  },
  data () {
    return {
      currentContentPath: '',
      currentDetailContent: null,
      currentDetailContentId: null,
      id: '',
      detailDefinitionChanged: false,
      saveDefinition: false,
      saveDefinitionTo: null,
      loadingDetail: true,
      closing: false,
      visualDefinition: null
    }
  },
  methods: {
    flapClicked (name) {
      this.loadingDetail = true
    },
    detailLoaded (content) {
      this.loadingDetail = false
    },
    formDataActionCalled (stay) {
      this.detailDefinitionChanged = false
      if (!stay && this.saveDefinitionTo === null) {
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_SHOWN}`, false)
        this.goToParentMenu()
      }
      this.saveDefinitionTo = null
      this.saveDefinition = false
      this.$emit('formDataActionCalled')
    },
    closeDetail () {
      this.closing = true
      if (!this.detailDefinitionChanged || (this.visualDefinition.definition && this.visualDefinition.definition.hideButtons)) {
        this.closeDetailWindow()
      } else {
        // Dialog
        let message = this.$ml.get('saveChangesAfterClose')
        let options = {
          okText: this.$ml.get('save'),
          cancelText: this.$ml.get('continueWithoutSaving'),
          customClass: 'sherpaDialog'
        }
        this.$dialog.confirm(message, options)
          .then((dialog) => {
            this.saveDefinition = true
          })
          .catch(() => {
            this.closeDetailWindow()
          })
      }
    },
    closeDetailWindow () {
      this.$router.push(this.currentContentPath).catch(() => {})
    },
    goToParentMenu () {
      var path = this.$route.matched[this.$route.matched.length - 1].path
      var menuParent = menu.methods.getDefaultParentMenuPath(null, this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`], path)
      this.$router.push(menuParent.parentContextPath + menuParent.contextPath).catch(() => {})
    },
    definitionChanged (requestObject, changed) {
      this.detailDefinitionChanged = changed
    },
    continueWithoutSaving () {
      this.detailDefinitionChanged = false
    },
    continueSaving (to) {
      this.saveDefinitionTo = to
      this.saveDefinition = true
    },
    validatingFormError () {
      this.saveDefinitionTo = null
      this.saveDefinition = false
    },
    getCurrentDetailName () {
      var result = null
      for (var i = 0; i < this.menu.length && !result; i++) {
        if (this.currentDetailContentId === this.menu[i].id) {
          result = this.menu[i].name
        }
      }
      return result
    },
    clickDetailAndClose (event) {
      // close detail if click is out of content
      if (event.target.id === 'detail') {
        // this.closeDetail()
      } else {
        var detailClassFound = false
        for (var i = 0; i < event.target.classList.length && !detailClassFound; i++) {
          detailClassFound = (event.target.classList[i] === 'detail-area')
        }
        if (detailClassFound) {
          // this.closeDetail()
        }
      }
    }
  },
  beforeMount () {
    var currentContent = this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`]
    this.currentContentPath = currentContent.parentContextPath + currentContent.contextPath
    this.currentDetailContent = this.newCurrentDetailContent
    if (this.currentDetailContent) {
      this.currentDetailContentId = this.currentDetailContent.id
    }

    this.visualDefinition = new Visual(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_VISUALS}`], this.currentDetailContentId)

    this.id = this.detailId
    if (this.id === null) {
      if (this.$route.params.id) {
        this.id = this.$route.params.id
      } else if (this.currentDetailContent && this.currentDetailContent.requestDefinition && this.currentDetailContent.requestObject) {
        this.id = transport.methods.getIdValue(this.currentDetailContent.requestDefinition, this.currentDetailContent.requestObject)
      }
    }
    this.$store.dispatch(`${controlPanelTypes.CONTROL_PANEL_NAMESPACE}/${controlPanelTypes.CONTROL_PANEL_CLOSE}`)
  },
  computed: {
    newCurrentDetailContent () {
      return this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_DETAIL_CONTENT}`]
    }
  },
  watch: {
    newCurrentDetailContent (newCurrentDetailContent) {
      this.currentDetailContent = newCurrentDetailContent
      if (this.currentDetailContent && this.currentDetailContent.requestDefinition && this.currentDetailContent.requestObject) {
        this.currentDetailContentId = this.currentDetailContent.id
        this.id = transport.methods.getIdValue(this.currentDetailContent.requestDefinition, this.currentDetailContent.requestObject)

        if (this.currentDetailContentId) {
          this.visualDefinition = new Visual(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_VISUALS}`], this.currentDetailContentId)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.loadingDetail {
  position: absolute;
  top: calc(50% - 16px);
  left: 0;
  right: 0;
}

#detail {
  display: block !important;
  z-index: 1000 !important;
  padding-top: 0;

  > .w3-modal-content {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    left: 100px;
    width: auto;
    height: 100%;
    background: none;

    > .w3-container {
      margin: 0;
      padding: 0;
      height: 100%;

      #container_menu_detail {
        width: 55px;

        .detail-menu-container {
          margin-top: 0px;

          > div {
           position: relative;
          }

          a > div {
            position: relative;
            width: 100%;
            height: 55px;
            background-color: #efefef;
            border-bottom: 2px solid grey;
            transition: background-color 0.2s ease-in;

            .icon_menu {
              position: absolute;
              right: 0;
              left: 0;
              text-align: center;
              top: 50%;
              transform: translateY(-50%);

              i {
                font-size: 23px;
              }
            }
          }

          a.link-active > div,
          a:hover > div {
            background-color: white;
            transition: background-color 0.3s ease-in;
          }

          .tooltip {
            top: 13px !important;
            left: 55px !important;
            transform: initial !important;
            white-space: nowrap;
          }
        }
      }

      #container_detail {
        background-color: white;
        overflow-y: scroll;
        position: absolute;
        right: 0;
        bottom: 0;
        padding-bottom: 65px;
        left: 55px;
        top: 0;

        > #container_inner_detail {
          .detail-view {
            padding-top: 70px;
          }

          .definition-wrapper.group {
            float: left;
          }

          .close_detail {
            top: 16px;
            right: 43px;
            color: #ff7643;
            cursor: pointer;
            z-index: 20;
            position: fixed;

            i {
              font-size: 18px;
              transition: color 0.2s ease-in;

              &:hover {
                color: #FFBD42;
              }
            }
          }

          .detail {
            margin: 0 20px;
            height: 100%;

            .definition-title {
              padding-top: 18px;
              background-color: #fff;
              border-bottom: 1px dotted #cfcfcf;
              position: fixed;
              z-index: 11;
              top: 0;
              right: 0;
              left: 174px;
              padding-left: 0px;
            }

            .apartat_detail {
              width: 100%;
              min-height: 130px;
              margin: 10px 0;
              padding: 5px 15px;
              background-color: #efefef;

              p {
                font-family: Barlow;
                font-size: 1.2em;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: 1;
                letter-spacing: normal;
                color: #342d38;
              }

              ul {
                list-style: none;

                li span {
                  font-family: Barlow;
                  font-size: 1em;
                  font-weight: normal;
                  font-style: normal;
                  font-stretch: normal;
                  line-height: 1.25;
                  letter-spacing: normal;
                  color: #342d38;
                }

                span:first-child {
                  font-weight: bold;
                }
              }
            }

            .template-mosaico {
              .languageSelectorOrTask {
                top: -17px;
              }
            }

            #gjs {
              width: auto !important;
              height: auto !important;
              position: fixed;
              left: 175px;
              right: 52px;
              top: 160px;
              bottom: 70px;
            }

            .html {
              #gjs {
                position: fixed;
                left: 5px;
                right: 5px;
                top: 55px;
                bottom: 5px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#contenidor_plantilles {
  margin: 30px 0 100px;
  padding: 0;

  #pujar_plantilla {
    position: relative;
    width: 20%;
    height: 240px;
    background-color: #fffcf5;
    border-radius: 8px;
    border: 2px dashed #ffbf28;
  }
}
#contenidor_menu_plantilles {
  margin-top: 30px;

  .slider_plantilles {
    width: 100%;
    height: auto;
    padding: 0 100px;
    overflow: hidden;

    #ctrl_esquerra_items {
      position: absolute;
      top: 90px;
      left: -45px;
      z-index: 99;
      color: #ff7643;
      cursor: pointer;
    }

    #ctrl_dreta_items {
      position: absolute;
      top: 90px;
      right: -45px;
      z-index: 99;
      color: #ff7643;
      cursor: pointer;
    }

    .slick-slide {
      width: 100%;
      height: 240px;
      padding: 0 15px;
      opacity: 0.3;
      overflow: hidden;
    }

    .slick-center {
      opacity: 1;
    }

    .plantilla img {
      width: 100%;
      max-height: 400px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/detail/index.vue